import impeccableReputationChecksService from '@/api/impeccable-reputation-checks-service';

export const getDefaultRejectedPermitFilterParams = () => ({});

const state = {
  rejectedPermits: [],
  rejectedPermitsPagination: {},
  rejectedPermitFilterParams: getDefaultRejectedPermitFilterParams(),
};

const mutations = {
  SET_REJECTED_PERMITS(state, { data, current_page, per_page, total }) {
    state.rejectedPermits = data;
    state.rejectedPermitsPagination = {
      current_page,
      per_page,
      total,
    };
  },

  SET_FILTER_PARAMS(state, params) {
    state.rejectedPermitFilterParams = params;
  },
};

const actions = {
  fetchRejectedPermits({ commit }, params) {
    commit('SET_FILTER_PARAMS', params);
    return impeccableReputationChecksService.getRejectedPermits(params).then((res) => {
      commit('SET_REJECTED_PERMITS', res.data);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
